import { FC } from 'react'

import Button from '~elements/Button'
import { AssetApproverFragment } from '~generated/operations'
import SendIcon from '~icons/send.svg'
import { AUTH_DATA_KEYS } from '~lib/constants'
import { stopPropagation } from '~lib/helpers'
import useCookie from '~lib/hooks/useCookie'
import Col from '~lib/ui-kit/Col'
import Space from '~lib/ui-kit/Space'
import Text from '~lib/ui-kit/Text'
import Tooltip from '~lib/ui-kit/TooltipV2'
import ApproversMenu from '~modules/assetModules/elements/ApproversMenu'

interface ApprovalsProps {
  approversDetails: AssetApproverFragment[]
  hasContent: boolean
  readOnly?: boolean
  onApproveClick: VoidFunction
  onSendForReviewClick: VoidFunction
  showApproveBtn?: boolean
}

const Approvals: FC<React.PropsWithChildren<ApprovalsProps>> = ({
  approversDetails,
  hasContent,
  readOnly,
  onApproveClick,
  onSendForReviewClick,
  showApproveBtn,
}) => {
  const cookie = useCookie()
  const userId = cookie[AUTH_DATA_KEYS.USER_ID]

  return (
    <Col>
      <Space align="center" gutter="2" onClick={stopPropagation}>
        {showApproveBtn && (
          <ApproversMenu
            readOnly={readOnly}
            userId={userId}
            onApprove={onApproveClick}
            onSendForApproval={onSendForReviewClick}
            approversDetails={approversDetails}
          />
        )}

        {!showApproveBtn && !readOnly && hasContent && (
          <Button
            endIcon={<SendIcon />}
            title="Send for approval"
            variant="plainLavenderInvert"
            onClick={onSendForReviewClick}
          >
            <Text type="body-s">Send for approval</Text>
          </Button>
        )}

        {!showApproveBtn && !readOnly && !hasContent && (
          <Tooltip content="Add content before you can send for approval">
            <Button aria-disabled endIcon={<SendIcon />} title="Send for approval" variant="default">
              <Text type="body-s">Send for approval</Text>
            </Button>
          </Tooltip>
        )}
      </Space>
    </Col>
  )
}

export default Approvals
